import gql from 'graphql-tag';

export const SEARCH_INSTRUMENTS = gql`
  query searchInstruments ($idValue: String!) {
    SearchInstruments(name:$idValue) {
      id,
      name
    }
  }
`;

export const GET_INSTRUMENT = gql`
  query getInstrument (
    $id: ID,
    $type: String,
    $name: String
  ) {
  Instrument(
    id: $id,
    type: $type,
    name: $name
  ) {
    id,
    type,
    name,
    maker {
      id,
      fullName,
      __typename
    }
    recordings {
      id,
      title,
      __typename
    },
    contributedBy {
      id,
      contributor {
        id,
        fullName,
        __typename
      }
      role,
      isCredited,
      creditText,
      featured
    }
  }
}
`;

export const CREATE_INSTRUMENT = gql`
  mutation createInstrument (
    $id: ID,
    $type: String,
    $name: String
  ) {
  CreateInstrument(
    id: $id,
    type: $type,
    name: $name
  ) {
    id,
    type,
    name
  }
}
`;

export const UPDATE_INSTRUMENT = gql`
  mutation updateInstrument (
    $id: ID!,
    $type: String,
    $name: String
  ) {
  UpdateInstrument(
    id: $id,
    type: $type,
    name: $name
  ) {
    id,
    type,
    name
  }
}
`;

export const DELETE_INSTRUMENT = gql`
  mutation deleteInstrument (
    $id: ID!
  ) {
  DeleteInstrument(
    id: $id
  ) {
    id
  }
}
`;
// AddInstrumentRecordings(
//   from: _RecordingInput!
//   to: _InstrumentInput!
// ): _AddInstrumentRecordingsPayload
// RemoveInstrumentRecordings(
//   from: _RecordingInput!
//   to: _InstrumentInput!
// ): _RemoveInstrumentRecordingsPayload
// AddInstrumentContributedBy(
//   from: _ContributionInput!
//   to: _InstrumentInput!
// ): _AddInstrumentContributedByPayload
// RemoveInstrumentContributedBy(
//   from: _ContributionInput!
//   to: _InstrumentInput!
// ): _RemoveInstrumentContributedByPayload
